import { WebComponentBaseClass } from '/third_party/web-component-base-class/dist/web-component-base-class.js';
import '/third_party/vicowa-web-components/dist/vicowa-button/vicowa-button.js';
import '/third_party/vicowa-web-components/dist/vicowa-sidebar/vicowa-sidebar.js';
import '/third_party/vicowa-web-components/dist/vicowa-string/vicowa-string.js';

const webComponentName = 'vicowa-web-layout';
window.customElements.define(webComponentName, class extends WebComponentBaseClass {
	static get is() { return webComponentName; }

	static get properties() {
		return {};
	}

	constructor() { super(); }

	attached() {
		const mediaChange = window.matchMedia('(max-width: 600px)');
		setTimeout(() => {
			const checkMedia = (p_Result) => {
				this.$.sideBar.expanded = !p_Result.matches;
			};
			checkMedia(mediaChange);
			mediaChange.addListener(checkMedia);
		}, 1000);

		this.addAutoEventListener(this.$.toggleExpand, 'click', (p_Event) => {
			this.$.sideBar.expanded = !this.$.sideBar.expanded;
			const handleOutsideClick = (p_ClickEvent) => {
				const viewRect = this.$.panel.getBoundingClientRect();
				if (p_ClickEvent.clientX > viewRect.right || p_ClickEvent.clientX < viewRect.left || p_ClickEvent.clientY > viewRect.bottom || p_ClickEvent.clientY < viewRect.top) {
					this.$.sideBar.expanded = false;
					this.removeAutoEventListener(window, 'click', handleOutsideClick);
				}
			};
			if (this.$.sideBar.expanded) {
				this.addAutoEventListener(window, 'click', handleOutsideClick);
			}
			p_Event.cancelBubble = true;
		});
	}

	static get template() {
		return `
<style>
	:host {
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
		}

	.main {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;

			align-content: stretch;
			align-items: stretch;
		}

		#header {
			flex-grow: 0;
			flex-shrink: 0;
			flex-basis: var(--vicowa-web-layout-header-height, 0);
			background: var(--vicowa-web-layout-header-background, transparent);
			transition: flex-basis .5s;
			overflow: hidden;
			display: flex;
			flex-direction: row;
			box-shadow: var(--vicowa-web-layout-header-shadow);
		}

		#toggle-expand {
			display: none;
			flex: 0 0 var(--vicowa-web-layout-header-height, 30px);
			--vicowa-button-width: var(--vicowa-button-height, 100%);
			--vicowa-button-padding: calc(calc(var(--vicowa-button-height, 30px) - 24px) / 2);
			--vicowa-icon-fill-color: black;
			--vicowa-icon-line-color: none;
		}

		#panel {
			box-shadow: var(--vicowa-web-layout-panel-shadow);
			background: var(--vicowa-web-layout-panel-background, transparent);
			display: flex;
			flex-direction: column;
			height: 100%;
		}

		#content {
			box-shadow: var(--vicowa-web-layout-content-shadow);
			background: var(--vicowa-web-layout-content-background, transparent);
			overflow: auto;
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			right: 0;
		}

		#sidebar-container {
			position: relative;
			flex: 1 1 auto;
			--vicowa-sidebar-size: var(--vicowa-web-layout-panel-width);
		}

		vicowa-sidebar {
			position: absolute;
			left: 0;
			top: 0;
			right: 0;
			bottom: 0;
		}
		
		slot[name="logo"] {
			flex: 0 0 auto;
			display: flex;
			align-items: center;
			justify-content: center;
		}

	@media screen and (max-width: 600px) {
			#toggle-expand {
				display: block;
			}
		}
	</style>
		<div class="main">
			<vicowa-base-icons name="base"></vicowa-base-icons>
			<div id="header">
				<vicowa-button id="toggle-expand" icon="base:hamburger"></vicowa-button>
				<slot name="header"></slot>
			</div>
			<div id="sidebar-container">
				<vicowa-sidebar id="side-bar" location="left">
					<div slot="side-content" id="panel">
						<slot name="logo"></slot>
						<slot name="panel"></slot>
					</div>
					<div slot="main-content" id="content">
						<slot name="content"></slot>
					</div>
				</vicowa-sidebar>
			</div>
		</div>
		`;
	}
});


